import React, { Component } from "react";
import { connect } from "react-redux";
import Confirmation from "../components/Confirmation";

class ConfirmationContainer extends Component {
  render() {
    return <Confirmation reference={this.props.reference} />;
  }
}

const mapStateToProps = state => {
  return {
    reference: state.workReferences.reference.data
  };
};

export default connect(
  mapStateToProps,
  null
)(ConfirmationContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/reference/containers/ConfirmationContainer.js